import React, { useState } from 'react'
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

const PredictionModal = ({ show, onHide, dailyPredictionList, predictionTitle }) => {
    const [headings, setHeadings] = useState(['Emotions', 'Health', 'Profession', 'Luck', 'Personal_Life', 'Travel'])
    return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                backdrop="static"
                keyboard={false}
                centered
                dialogClassName="responsive-modal"
            >
                <Modal.Header
                    closeButton
                    style={{
                        backgroundColor: "#A52444",
                        color: "white",
                        borderBottom: "none",
                    }}
                >
                    <Modal.Title
                        style={{
                            fontSize: "clamp(18px, 2.5vw, 22px)",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            flexWrap: "wrap",
                        }}
                    >
                        <span role="img" aria-label="sparkles">🌟</span>
                        Daily Prediction - {predictionTitle}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body
                    style={{
                        maxHeight: "60vh",
                        overflowY: "scroll",

                        backgroundColor: "#fff",
                    }}
                >
                    <div className='responsive-horoscope-body'>
                        {Object.entries(dailyPredictionList || {}).map(([key, value], index) => (
                            <div key={index} style={{ marginBottom: "1.5rem" }}>
                                <h5
                                    style={{
                                        color: "#A52444",
                                        fontSize: "1.1rem",
                                        fontWeight: 600,
                                        marginBottom: "0.5rem",
                                        borderBottom: "1px solid #ddd",
                                        paddingBottom: "0.25rem",
                                        textTransform: "capitalize",
                                        textAlign: "center",
                                    }}
                                >
                                    {headings[index]}
                                </h5>
                                <p
                                    style={{
                                        fontSize: "0.95rem",
                                        textAlign: "justify",
                                        lineHeight: "1.6",
                                    }}
                                >
                                    {value}
                                </p>
                            </div>
                        ))}
                    </div>

                </Modal.Body>

                <Modal.Footer
                    style={{
                        backgroundColor: "#fff",
                        borderTop: "none",
                        justifyContent: "center",
                    }}
                >
                    <Button
                        variant="light"
                        onClick={onHide}
                        style={{
                            backgroundColor: "#A52444",
                            border: "none",
                            padding: "6px 20px",
                            fontWeight: 500,
                            color: "#fff",
                            borderRadius: "20px",
                        }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    )
}

export default PredictionModal
